import { Component, EventEmitter, Injector, OnDestroy, OnInit, Output } from "@angular/core";
import * as moment from "@node_modules/moment-timezone";
import { Subscription } from "@node_modules/rxjs";
import { AppComponentBase } from "@shared/app-component-base";
import { AgendaServiceProxy, CreateEventoDto, CreateHorarioDisponivelDto, DayOfWeek, EssentialProfisisonalSaudeDto, EventoServiceProxy, Int32NameValueDto, ProfissionalSaudeServiceProxy, TipoEvento, TipoRecorrencia } from "@shared/service-proxies/service-proxies";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './create-horario-disponivel.component.html',
    styleUrls: ['./create-horario-disponivel.component.scss'],
})
export class CreateHorarioDisponivelComponent extends AppComponentBase implements OnInit, OnDestroy {
    private _subscriptions: Subscription[] = [];

    protected title: string = "Criar novo horário";
    protected subtitle: string = "Crie um novo horario livre";
    protected saving: boolean = false;
    protected diaDaSemana: number;
    protected diasDaSemana: Int32NameValueDto[];
    protected diasSelecionados: DayOfWeek[] = [];
    protected agendaId: string;
    protected horario: CreateHorarioDisponivelDto = new CreateHorarioDisponivelDto;
    protected profissionais: EssentialProfisisonalSaudeDto[] = [];
    protected profissionaisSelecionados: EssentialProfisisonalSaudeDto[] = [];
    protected profissionaisFiltrados: EssentialProfisisonalSaudeDto[] = [];
    protected nome: string = '';

    @Output() onSave = new EventEmitter<any>();

    constructor(
        injector: Injector,
        private _agendaService: AgendaServiceProxy,
        private _eventoService: EventoServiceProxy,
        private _profissionalAppService: ProfissionalSaudeServiceProxy,
        public bsModalRef: BsModalRef
    ) {
        super(injector)
    }

    ngOnInit(): void {
        if (this.appSession.clinicaId == null) {
            this.getProfissional();
        } else {
            this._subscriptions.push(this.getProfissionais());
        }
        this.horario.diaDaSemana = this.diaDaSemana;
        this._subscriptions.push(this.getDiasDaSemana());
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(s => s.unsubscribe());
    }

    protected atualizarLista(nome: string) {
        if (!nome) {
            this.profissionaisFiltrados = [];
        } else {
            this.profissionaisFiltrados = this.profissionais
                .filter(x => x.nome.toLowerCase().includes(nome.toLowerCase()))
                .filter(x => this.profissionaisSelecionados.every(y => y.id !== x.id));
        }
    }

    protected insertProfissional(profissional: EssentialProfisisonalSaudeDto): void {
        this.profissionaisSelecionados = [];

        this.profissionaisSelecionados.push(profissional);

        this.profissionaisFiltrados = [];
        this.nome = '';
    }

    protected removeProfissional(profissional: EssentialProfisisonalSaudeDto): void {
        this.profissionaisSelecionados = this.profissionaisSelecionados.filter(x => x.id != profissional.id);
    }

    protected save(): void {
        if(this.diasSelecionados.length == 0){
            abp.message.info("Selecione pelo menos um dia!");
            return;
        }

        if (this.appSession.clinicaId && this.profissionaisSelecionados.length === 0) {
            abp.message.info("Selecione o profissional responsável pelo horário.");
            return;
        }
        this.saving = true;
        abp.ui.setBusy();

        this.horario.agendaId = this.agendaId;

        const data = moment().format('YYYY-MM-DD'); // apenas a data
        const start = moment.utc(`${data} ${this.horario.inicio}`, 'YYYY-MM-DD HH:mm');
        const end = moment.utc(`${data} ${this.horario.fim}`, 'YYYY-MM-DD HH:mm');

        let profissionalId: string;
        if (this.appSession.clinicaId) {
            if (this.profissionaisSelecionados && this.profissionaisSelecionados.length > 0) {
                profissionalId = this.profissionaisSelecionados[0].id;
            }
        } else {
            profissionalId = this.appSession.profissionalId;
        }

        const evento = new CreateEventoDto({
            agendaId: this.agendaId,
            pacienteId: this.appSession.pacienteId,
            profissionalId: profissionalId,
            clinicaId: this.appSession.clinicaId,
            titulo: "Horário Disponível",
            descricao: "",
            inicio: start,
            fim: end,
            tipo: TipoEvento._0,
            ehRecorrente: true,
            tipoRecorrencia: TipoRecorrencia._1,
            diasDaSemana: this.diasSelecionados,
            dataFimRecorrencia: null,
            ignorarEventosExistentes: false
        });

        this._eventoService
            .create(evento)
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy();
                    this.saving = false;
                })
            )
            .subscribe(() => {
                this.onSave.emit();
                this.bsModalRef.hide();
            })
    }

    protected selectedDia(dia) {
        if (this.diasSelecionados.some(x => x == dia))
            this.diasSelecionados = [...this.diasSelecionados.filter(x => x != dia)];
        else
            this.diasSelecionados.push(dia);
    }

    private getDiasDaSemana(): Subscription {
        abp.ui.setBusy();
        return this._agendaService
            .getDaysOfWeek()
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy()
                })
            )
            .subscribe((result: Int32NameValueDto[]) => {
                this.diasDaSemana = result;
            });
    }

    private getProfissionais(): Subscription {
        abp.ui.setBusy();
        return this._profissionalAppService
            .getProfissionaisByClinica(this.appSession.clinicaId)
            .pipe(
                finalize(() => {
                    abp.ui.clearBusy();
                })
            )
            .subscribe((result) => {
                this.profissionais = result;
            })
    }

    private getProfissional(): void {
        abp.ui.setBusy();
        this._profissionalAppService.get(this.appSession.profissionalId).pipe(
            finalize(() => {
                abp.ui.clearBusy();
            })
        ).subscribe((result) => {
            let profissional = new EssentialProfisisonalSaudeDto();
            profissional.cpf = result.cpf;
            profissional.id = result.id;
            profissional.nome = result.nome
            this.insertProfissional(profissional);
        })
    }
}
